import React from 'react';
import { Typography } from 'antd';
import moment from "moment/moment";
import 'moment-duration-format';

const BucketPullDetails = ({ bucketPull }) => {
    if (!bucketPull) return <Typography.Text type="secondary">Select an bucketPull to view details.</Typography.Text>;

    return (
        <div>
            <Typography.Title level={4}>{bucketPull.paperName}</Typography.Title>
            <p><strong>Pulled At:</strong> {moment(bucketPull.pulledAt).format('h:mm:ss a')}</p>
            {bucketPull?.duration && <p><strong>Duration:</strong> {moment.duration(bucketPull.duration).format("HH:mm:ss.SSS", { trim: false })}</p>}
            <p><strong>Created At:</strong> {moment(bucketPull.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</p>
        </div>
    );
};

export default BucketPullDetails;
